export const GET_MAP_FIELDS = 'GET_MAP_FIELDS';
export const IS_LOADING_GET_MAP_FIELDS = 'IS_LOADING_GET_MAP_FIELDS';
export const CREATE_MAP_FIELD = 'CREATE_MAP_FIELD';
export const IS_LOADING_CREATE_MAP_FIELD = 'IS_LOADING_CREATE_MAP_FIELD';
export const UPDATE_MAP_FIELD = 'UPDATE_MAP_FIELD';
export const IS_LOADING_UPDATE_MAP_FIELD = 'IS_LOADING_UPDATE_MAP_FIELD';
export const DELETE_MAP_FIELD = 'DELETE_MAP_FIELD';
export const IS_LOADING_DELETE_MAP_FIELD = 'IS_LOADING_DELETE_MAP_FIELD';
export const DELETE_MAP_FIELDS = 'DELETE_MAP_FIELDS';
export const IS_LOADING_DELETE_MAP_FIELDS = 'IS_LOADING_DELETE_MAP_FIELDS';
export const ADD_FIELD_TO_MAP = 'ADD_FIELD_TO_MAP';
export const REMOVE_FIELD_FROM_MAP = 'REMOVE_FIELD_FROM_MAP';
export const REMOVE_FIELDS_FROM_MAP = 'REMOVE_FIELDS_FROM_MAP';
// Templates
export const GET_MAP_FIELDS_TEMPLATES = 'GET_MAP_FIELDS_TEMPLATES';
export const IS_LOADING_GET_MAP_FIELDS_TEMPLATES = 'IS_LOADING_GET_MAP_FIELDS_TEMPLATES';
export const DELETE_MAP_FIELD_TEMPLATE = 'DELETE_MAP_FIELD_TEMPLATE';
export const IS_LOADING_DELETE_MAP_FIELD_TEMPLATE = 'IS_LOADING_DELETE_MAP_FIELD_TEMPLATE';